<ng-container>
    <div class="button-container d-flex flex-row align-items-center psic-gap-2">
        @for (item of field.options.optionsList; track item) {
        <button
            class="button d-flex flex-row justify-content-center align-items-center caption-bold psic-gap-1 psic-px-3 psic-py-2"
            [disabled]="field.disabled || field.readonly || item.disabled"
            [class.active]="item.value == selectedOption"
            (click)="onClick(item.value, $event)"
            [ngClass]="{ stretch: field.additionalContext.isStretch }"
        >
            <!-- Display Icon before button caption -->
            @if (item.iconName) {
            <mat-icon [svgIcon]="item.iconName"></mat-icon>
            }
            <!-- Display Status Icon before button caption -->
            @if (field.additionalContext.isDynamicStatus) {
            <div class="status-icon"></div>
            }
            <span>{{ item.caption }}</span>
        </button>
        }
    </div>
</ng-container>
